module.exports = __webpack_public_path__ + "static/media/carroussel_25.f00d653a.jpg";